import { Link, Navigate, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import Swal from "sweetalert2";

import {
  addContractType,
  checknomContrat,
} from "../../../../services/RHService/ContractTypeService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddContractType = () => {
  const navigate = useNavigate();
  const [nomcontratError, setNomcontratError] = useState("");
  const [nomContrat, setNomContrat] = useState("");
  const [duree, setDuree] = useState("");
  const [formData, setFormData] = useState({ advantage: false });
  const handleSubmit = (event) => {
    event.preventDefault();

    console.log(formData.advantage);

    let checknomContratExist = false;
    checknomContrat(nomContrat, getCurrentUserId())
      .then((response) => {
        checknomContratExist = response.data.success;
      })
      .catch((e) => {
        console.log("error", e);
      });
    if (checknomContratExist) {
      setNomcontratError("Nom de Contrat déja existe");
    } else {
      setNomcontratError("");
    }
    if (!checknomContratExist) {
      try {
        let addContractTypeModel = {
          idUser: getCurrentUserId(),
          nomContrat: nomContrat,
          duree: duree,
          advantage: formData.advantage,
        };
        addContractType(addContractTypeModel).then((response) => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Type de contrat inséré avec succès",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            navigate(`/contracttype`);
          }, 2000);
        });
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Une erreur s'est produite lors de l'insertion",
        });
      }
    }
  };

  const onChangeNameContratHandler = (event) => {
    setNomContrat(event.target.value);
  };
  const onChangeDureeHandler = (event) => {
    setDuree(event.target.value);
  };
  const handleInputChange = async (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    setFormData({
      ...formData,
      [target.name]: value,
    });
  };

  return (
    <section className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0"> Ajouter un Type de contrat</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link
                    to="/settings/contract_typelist"
                    style={{ color: "black" }}
                  >
                    Liste des types de contrat
                  </Link>
                </li>
                <li className="breadcrumb-item active">Ajouter un type</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Ajouter un type</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="form-group">
                          {/* <label for="exampleInputPassword1">Contrat</label> */}
                          <div className="form-group">
                            <label htmlFor="inputName">Contrat</label>
                            <input
                              placeholder="Ajouter libellé "
                              onChange={onChangeNameContratHandler}
                              type="text"
                              id="inputName"
                              className="form-control"
                            />
                          </div>
                          {/* <input type="text" className="form-control form-control-border" onChange={onChangeNameContratHandler} name="nomContrat" placeholder="Contrat" /> */}
                        </div>
                        {nomcontratError && (
                          <p style={{ color: "red" }}>{nomcontratError}</p>
                        )}

                        <div className="form-group">
                          {/* <label for="exampleInputPassword1">Durée</label>
                          <input type="text" className="form-control form-control-border" onChange={onChangeDureeHandler} name="duree" placeholder="Durée" /> */}
                          <div className="form-group">
                            <label htmlFor="inputName">Durée</label>
                            <input
                              placeholder="Ajouter libellé "
                              onChange={onChangeDureeHandler}
                              type="text"
                              id="inputName"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <div className="custom-control custom-checkbox mt-5">
                            <input
                              className="custom-control-input custom-control-input-dark"
                              value={formData.advantage}
                              onChange={handleInputChange}
                              type="checkbox"
                              id="customCheckbox7"
                              name="advantage"
                            />
                            <label
                              for="customCheckbox7"
                              className="custom-control-label"
                            >
                              Avantageux
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Confirmer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
export default AddContractType;
